let mouse_down = false;
let start_x, scroll_left;
const slider = document.querySelector('.reviews--reviews-container');

const set_scroll_midle = () => {
    const scroll_middle_pos = (slider.scrollWidth - slider.clientWidth) / 2;
    slider.scrollLeft = scroll_middle_pos;
}

const get_start_x = (e) => {
  if (e.pageX) {
    return e.pageX - slider.offsetLeft;
  } else if (e.changedTouches[0]) {
    return e.changedTouches[0].pageX - slider.offsetLeft;
  }
}

const start_dragging = (e) => {
  mouse_down = true;
  start_x = get_start_x(e);
  scroll_left = slider.scrollLeft;
}

const stop_dragging = (e) => {
  mouse_down = false;
}

const move = (e) => {
  e.preventDefault();
  if(!mouse_down) { return; }
  const x = get_start_x(e);
  const scroll = x - start_x;
  slider.scrollLeft = scroll_left - scroll;
}

// Add the event listeners
window.addEventListener('load', set_scroll_midle, false);
window.addEventListener('resize', set_scroll_midle, false);

slider.addEventListener('mousemove', move, false);
slider.addEventListener('mousedown', start_dragging, false);
slider.addEventListener('mouseup', stop_dragging, false);
slider.addEventListener('mouseleave', stop_dragging, false);

slider.addEventListener('touchmove', move, false);
slider.addEventListener('touchstart', start_dragging, false);
slider.addEventListener('touchend', stop_dragging, false);
slider.addEventListener('touchcancel', stop_dragging, false);